class UiQty extends HTMLElement {
  input: HTMLInputElement | null;
  max: number;
  data?: { id: number; qty: number }[];

  static observedAttributes = ["max"];

  constructor() {
    super();
    this.max = parseInt(this.getAttribute("max") ?? "1");
    this.input = this.querySelector("[data-qtyinput]");
    this.data = JSON.parse(this.querySelector("[data-qtydata]")?.innerHTML);
  }

  async connectedCallback() {
    this.querySelector("[data-less]")?.addEventListener("click", this.handleDec.bind(this));
    this.querySelector("[data-more]")?.addEventListener("click", this.handleInc.bind(this));

    window.addEventListener("variantchange", (e: Event) => {
      const newVariantId = e?.detail;
      const newQty = this.data?.find((x) => x.id == newVariantId)?.qty;
      if (newQty) {
        this.max = newQty;
        if (this.input?.value && parseInt(this.input.value) > newQty) this.input.value = newQty.toString();
      }
    });

    // handle max input change
    document
      .querySelector(".product__form")
      ?.querySelectorAll(".product__variant-buttons input[type=radio]")
      ?.forEach((input) => input.addEventListener("change", this.handleVariantChange));
  }

  handleDec(e: Event) {
    e.preventDefault();
    if (!this.input?.value) return;
    const val = parseInt(this.input.value);
    this.input.value = (val <= 1 ? 1 : val - 1).toString();
  }

  handleInc(e: Event) {
    e.preventDefault();
    if (!this.input?.value) return;
    const val = parseInt(this.input.value);
    this.input.value = (val >= this.max ? this.max : val + 1).toString();
  }
}

customElements.define("ui-qty", UiQty);
